import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { getCategories, IState, selectFeature } from './expense-data.reducer';
import { EntityDataStore } from '../entity-data/entity-data.store';
import { Expense } from './models/expense.model';
import { List } from 'immutable';
import { Observable } from 'rxjs';

@Injectable()
export class ExpenseDataStore extends EntityDataStore<IState, Expense> {
  constructor(store: Store<any>) {
    super(store, selectFeature);
  }

  getCategories(): Observable<List<string>> {
    return this.store.select(getCategories());
  }
}
